const initialCategories = [
  {
    name: 'Gym',
    tasks: [
      {
        title: 'Go to the Gym',
      },
      {
        title: 'Do Legs Workout',
      },
      {
        title: 'Drink Protein Shake',
      },
      {
        title: 'Warm Up 15 mins',
      },
    ],
  },
  {
    name: 'School',
    tasks: [
      {
        title: 'Go to the School',
      },
      {
        title: 'Eat Tiffin',
      },
    ],
  },
  {
    name: 'Office',
    tasks: [
      {
        title: 'Join the Meeting',
      },
      {
        title: 'Finish Tasks',
      },
      {
        title: 'Plan Project',
      },
    ],
  },
]


export default initialCategories;